/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum TypeOfPersonality {
    ISTP = 'ISTP',
    ISTJ = 'ISTJ',
    ESTP = 'ESTP',
    ESTJ = 'ESTJ',
    ISFP = 'ISFP',
    ISFJ = 'ISFJ',
    ESFP = 'ESFP',
    ESFJ = 'ESFJ',
    INTP = 'INTP',
    INTJ = 'INTJ',
    ENTP = 'ENTP',
    ENTJ = 'ENTJ',
    INFP = 'INFP',
    INFJ = 'INFJ',
    ENFP = 'ENFP',
    ENFJ = 'ENFJ',
}
